var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 40,
    viewBox: "0 0 29 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1619 38.7137C25.5883 39.0456 26.1095 39.235 26.6307 39.235C26.9626 39.235 27.3414 39.1401 27.6732 38.998C28.4787 38.6189 29 37.7661 29 36.8658V7.58178C29 3.41181 25.5883 0 21.4182 0H7.58178C3.41181 0 0 3.41173 0 7.58178V36.8184C0 37.7188 0.521253 38.5715 1.32678 38.9506C2.13229 39.3297 3.1275 39.2349 3.83819 38.6664L3.88546 38.6191L14.5006 29.7107L25.1148 38.6665L25.1621 38.7137H25.1619ZM14.5003 25.3038C14.0739 25.3038 13.6475 25.4459 13.2683 25.7302L3.79131 33.7383V7.58176C3.79131 5.49673 5.49718 3.79086 7.5822 3.79086H21.4186C23.5037 3.79086 25.2095 5.49673 25.2095 7.58176V33.7857L15.7325 25.7775C15.3534 25.4933 14.927 25.3036 14.5006 25.3036L14.5003 25.3038Z",
    fill: "#2EC7DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkBlue);
export default __webpack_public_path__ + "static/media/bookmark-blue.8d61525c266bd5d8f387662783fa0d6a.svg";
export { ForwardRef as ReactComponent };